import { transparentize } from 'polished'
import styled from 'styled-components'

export const ActionButton = styled.button<{ pressed?: boolean }>`
    position: relative;
    background: ${({ theme, pressed }) => (pressed ? theme['gray-200'] : theme['gray-0'])};
    border: 1px solid var(--gray-200);
    width: 40px;
    height: 40px;
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    box-shadow: 0px 0px 4px ${({ theme }) => transparentize(0.8, theme['gray-900'])};
    cursor: pointer;
    color: var(--gray-1000);

    svg {
        path {
            fill: var(--gray-1000);
        }
    }
`

export const ActionsWrapperContainer = styled.div`
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
    transition: 0.3s all;
`

export const ActionsContainer = styled.div`
    position: absolute;
    bottom: 20px;
    left: calc(50%);
    transform: translateX(-50%);
    display: flex;
    flex-direction: row;
    gap: 15px;
`

export const SearchContainer = styled.div`
    position: absolute;
    bottom: 20px;
    right: 20px;
    display: flex;
    gap: 15px;
    align-items: center;
    justify-content: center;
`

export const CloseBowtieContainer = styled.div`
    position: absolute;
    bottom: 20px;
    left: 20px;
    display: flex;
    gap: 15px;
    align-items: center;
    justify-content: center;

    .rigTitle {
        font-size: 22px;
        color: var(--gray-900);
        opacity: 1;
    }
`
